import React from "react";
import { useState } from "react";
import { ReactComponent as CloseX } from "../icons/close-x.svg";
import { ReactComponent as Active } from "../icons/checkmark-circle.svg";
import { ReactComponent as Inactive } from "../icons/circle-x.svg";
import { ReactComponent as NoUSMail } from "../icons/nousmail_color.svg";
import { ReactComponent as USMail } from "../icons/mailbox_color.svg";


export default function Modal({ scope, children, contentId, modalClass, isOpen, showClose, onClose, header, active, nousmail, showActiveStatus, showNoUSMail, addCheckboxHandler}) {
  const [isActive, setIsActive] = useState(active);
  const [isNoUSMail, setIsNoUSMail] = useState(nousmail);

  if (!isOpen) return null;  // Don't return anything if we're not supposed to be showing the modal

  const handleBackdropClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  }

  const handleStatusCheckboxChange = (e) => {
    switch(e.target.name) {
      case 'nousmail':
        setIsNoUSMail(e.target.checked);
        break;
      case 'active':
        setIsActive(e.target.checked);
        break;
      default:
        break;
    }
  }

  const thisScope = (typeof(scope) === 'string' ? document.querySelector(scope) : window);
  const scrollY = thisScope.scrollY;
  const transformVal = "translate(0, " + scrollY + "px)";

  return (
    <div className="mymodal mymodal-container" style={{ transform: transformVal}}>
      <ModalBackdrop handleBackdropClick={handleBackdropClick} />
      <div className={`mymodal-dialog ${modalClass}`}>
        <div className="mymodal-header">
          <div className="mymodal-header-content">
            {showActiveStatus &&
              <div className="activeStatus">
                {isActive
                  ?<Active title="Member is active" alt="memeber is active" />
                  :<Inactive title="Member is inactive" alt="member is inactive" />
                }
              </div>
            } 
            <div>{header}</div>
            {showNoUSMail &&
              <div className="nousmailStatus">
                {isNoUSMail 
                  ?<NoUSMail title="No US Mail will be sent" alt="No US Mail will be sent" />
                  :<USMail title="US Mail will be sent" alt="US Mail will be sent" />
                }
              </div>
            }
          </div>
          {showClose && <button className="closeBtn" onClick={onClose}><CloseX title="Close dialog" alt="close dialog" /></button>}
        </div>
        <div id={contentId?contentId:''} className="mymodal-content">
          {/* Need to clone the children to add a prop for the form */}
          {addCheckboxHandler 
            ? React.cloneElement(children, { handleStatusCheckboxChange: handleStatusCheckboxChange })
            : children
          }
        </div>
      </div>
    </div>
  );
}

function ModalBackdrop({ handleBackdropClick }) {
  return (
    <div className="mymodal-backdrop" onClick={handleBackdropClick}></div>
  )
}